export { default } from './StepIcon';